import { MassagedBikeAndSub, BIKE_VARIANTS } from "./lib";
import Link from "next/link";
import Image from "/components/cms/image";
import { cn } from "/lib/utils";

export const BikeCard = ({ bike, className }: { bike: MassagedBikeAndSub; className?: string }) => {
  const { model, brand, variant, subscriptions, pageLink, image, availability } = bike;

  const passengers = BIKE_VARIANTS[variant].passengers;
  const price = subscriptions?.at(0)?.price ?? null;

  return (
    <div
      className={cn(
        `grid grid-cols-3 min-h-[380px] h-[600px] max-w-[500px] min-w-[200px] items-stretch border-2 border-black border-solid`,
        className
      )}
    >
      <Link
        href={pageLink.href}
        className="self-start row-start-1 row-span-1 col-span-3 items-center w-full grid grid-cols-subgrid grid-flow-row p-2 md:p-4"
      >
        <div className="col-start-1 col-span-2 md:col-span-3 lg:col-span-2">
          <h3 className="md:text-[24px] lg:text-[28px] whitespace-nowrap">{model}</h3>
          <h4 className="md:text-[20px] lg:text-[24px]">{brand}</h4>
        </div>
        <p className="md:col-span-3 lg:col-span-1 md:justify-self-start justify-self-end lg:justify-self-end text-[16px] whitespace-nowrap">
          <b>{passengers} passasjerer</b>
        </p>
      </Link>
      <div className="col-span-3 row-span-3 text-white w-full px-4">
        {image ? (
          <Link href={pageLink.href}>
            <Image className="inline-grid items-center h-full" imageObject={image}></Image>
          </Link>
        ) : null}
      </div>
      {price ? (
        <div className="row-span-1 w-full grid grid-cols-subgrid col-span-3 items-center self-end p-2 md:p-4 md:gap-4 lg:gap-0">
          <div className="col-start-1 col-span-2 md:col-span-3 md:justify-self-center lg:justify-self-start lg:col-span-2 flex flex-col leading-snug">
            <p className="text-[14px] md:text-[16px]">fra</p>
            <p className="text-[32px] md:text-[42px] leading-none">{price}</p>
            <p className="text-[14px] md:text-[16px]">kr/mnd</p>
          </div>
          <div className="md:col-span-3 lg:col-span-1 md:justify-self-center lg:justify-self-end justify-self-end flex flex-col items-between gap-2">
            <Link
              href={pageLink.href}
              className="underline text-black text-[14px] lg:text-[16px] whitespace-nowrap font-bold self-center"
            >
              Les mer
            </Link>
            {availability === "available" ? (
              <Link
                href={`/sykler/bestill/${bike.id}`}
                className="self-center px-5 py-3 rounded-full bg-green text-cream text-[16px] lg:text-[18px] font-medium leading-5 whitespace-nowrap"
              >
                {`Bestill her`}
              </Link>
            ) : (
              <Link
                href={`/sykler/${
                  availability === "coming_soon" ? "interessentliste" : "venteliste"
                }?bikeType=${brand} ${model}`}
                className="self-center px-5 py-3 rounded-full border-2 border-solid border-green text-green text-[16px] lg:text-[18px] font-medium leading-5 whitespace-nowrap"
              >
                {`Varsle meg`}
              </Link>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};
